import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { ContactFilterSavedApiInterface } from 'modules/contacts/types/contact-filter-interface'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

export function useContactSavedFilters() {
  const { user } = useUser()

  const { data: savedFields, mutate: mutateSavedFields } = useSWR<ContactFilterSavedApiInterface>(
    () => {
      if (user) {
        return `${CONTACT_API}/filters/list?pagination[limit]=50`
      }
      return null
    },
    baseFetcher,
  )

  return {
    savedFields,
    mutateSavedFields,
  }
}
